class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;
    this.timer = null;
    this.timerLeave = null;
    
    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
    this.addEventListener('mouseenter', e => {
      this.stopTimeout(this.timerLeave);
      let allDetails = document.querySelectorAll('header-menu details');
      if(allDetails.length > 0) {
        document.querySelectorAll('header-menu details').forEach(details => {
          if(details.open == true && details != this.mainDetailsToggle) {
            details.open = false;
            this.mainDetailsToggle.open = true;
          } 
        });
      }
      if(!this.mainDetailsToggle.open) {
        this.timer = setTimeout(() => this.mainDetailsToggle.open = true, 250);
      }
    });
    this.addEventListener('mouseleave', e => {
      this.stopTimeout(this.timer);
      if(this.mainDetailsToggle.open) {
        this.timerLeave = setTimeout(() => this.mainDetailsToggle.open = false, 500);
      }
    });

    let mainLinks = document.querySelectorAll('.main-header__menu-item');
    if(mainLinks.length > 0) {
      mainLinks.forEach(link => {
       link.addEventListener('mouseenter', e => {
        let allDetails = document.querySelectorAll('header-menu details');
        if(allDetails.length > 0) {
          allDetails.forEach(details => {
            details.removeAttribute('open');
          });
        }
       })
      });
    }

    if (this.mainDetailsToggle.dataset.target) {
        this.mainDetailsToggle.querySelector('summary').addEventListener('click', e => {
          e.preventDefault();
          window.location = this.mainDetailsToggle.dataset.target;
        });
    }
  }
  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }
  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();
    if (this.mainDetailsToggle.hasAttribute('open')) {
      console.log('play animation')
      this.animations.forEach(animation => animation.play());
    } else {
      this.animations.forEach(animation => animation.cancel());
    }
  }
  stopTimeout(timer) {
    clearTimeout(timer);
  }
  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}
customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.floor(this.header.getBoundingClientRect().bottom)}px`);
  }
}

customElements.define('header-menu', HeaderMenu);